import appApi from "../../utils/AppApi";
import errorHandler from "../../utils/ErrorHandler";
import {
  setQuizId,
  setLoadingQuizRequests,
  setAnsweredQuestoinsCount,
  setMaxAnswer,
  setCurrentQuestion,
  setLastQuestionId,
  setfinalizeReport,
} from "../../redux/actions/Quiz";

const QuizRequests = {
  getMatchId: () => {
    return (dispatch) => {
      dispatch(setLoadingQuizRequests(true));
      try {
        appApi.get("/quiz/getActiveQuizId").then(({ data }) => {
          dispatch(setLoadingQuizRequests(false));
          dispatch(setQuizId(data.activeQuizId));
        });
      } catch (error) {
        dispatch(setLoadingQuizRequests(false));
        errorHandler(error);
      } finally {
        dispatch(setLoadingQuizRequests(false));
      }
    };
  },
  startQuiz: (activeQuizId) => {
    return async (dispatch) => {
      dispatch(setLoadingQuizRequests(true));
      try {
        const response = await appApi.post("/quizTicket/create", {
          quizId: activeQuizId,
        });
        const { data } = response;
        dispatch(setLoadingQuizRequests(false));
        if (data && data.quizTicket) {
          return data.quizTicket;
        }
        throw new Error("Quiz ticket not found.");
      } catch (error) {
        dispatch(setLoadingQuizRequests(false));
        errorHandler(error);
      }
    };
  },
  getRemainingTime: async (ticketId) => {
    try {
      const response = await appApi.get(`/quizTicket/gettime/${ticketId}`);
      const { data } = response;
      if (data && data.remainingTime) {
        return data.remainingTime;
      }
    } catch (error) {
      console.log(error);
    }
  },
  setLastQuestion: (ticketId, questionId) => {
    appApi
      .post(`/quizTicket/setlastquestion/${ticketId}`, {
        lastQuestionId: questionId,
      })
      .then(({ data }) => {
        // console.log(data, "[setLastQuestion]");
      })
      .catch((error) => errorHandler(error));
  },
  getAnswerStatus: (id) => {
    return (dispatch) => {
      // before update
      dispatch(setAnsweredQuestoinsCount(0));
      dispatch(setMaxAnswer(0));
      try {
        appApi
          .get(`/quizanswer/getAnsweredQuestions/${id}`)
          .then(({ data }) => {
            dispatch(setAnsweredQuestoinsCount(data.quizAnswersNumber));
            dispatch(setMaxAnswer(data.quizMaxAnswer));
          });
      } catch (error) {
        errorHandler(error);
      }
    };
  },
  getQuestionByID: (id) => {
    return (dispatch) => {
      appApi
        .get(`/quizQuestion/getsingle/${id}`)
        .then(({ data }) => {
          dispatch(setCurrentQuestion(data.quizQuestion));
        })
        .catch((error) => errorHandler(error));
    };
  },
  getLastQuestionID: (ticketId) => {
    return (dispatch) => {
      appApi
        .get(`/quizTicket/getlastquestion/${ticketId}`)
        .then(({ data }) => {
          const lastQuestion = {
            id: data.lastQuestionId,
            type: data.questionType,
          };
          dispatch(setLastQuestionId(lastQuestion));
        })
        .catch((error) => console.log(error));
    };
  },
  finalizeAndGetReport: (matchId) => {
    return (dispatch) => {
      appApi
        .get(`/quiz/finalize/${matchId}`)
        .then(({ data }) => {
          localStorage.removeItem("Ticket");
          dispatch(setfinalizeReport(data));
        })
        .catch((error) => {
          errorHandler(error);
        });
    };
  },
};

export default QuizRequests;
